// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3URLF","infoBtn":"quickbooks_infoBtn__1-SP6","formBox":"quickbooks_formBox__FpP3x","formFooter":"quickbooks_formFooter__3ZUZr"};